import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { API } from "@/App";

const resolveSrc = (url) => (url?.startsWith("/uploads") ? `${API}${url}` : url);

export const PromoBanner = () => {
  const [banners, setBanners] = useState(null);
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    fetch(`${API}/banners`).then((r) => r.json()).then((d) => setBanners(Array.isArray(d) ? d : [])).catch(() => setBanners([]));
  }, []);

  useEffect(() => {
    if (!banners || banners.length < 2 || paused) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % banners.length), 6000);
    return () => clearInterval(t);
  }, [banners, paused]);

  if (banners !== null && banners.length === 0) {
    return <div className="pt-[150px] md:pt-[172px]" data-testid="promo-banner-spacer" />;
  }

  return (
    <section data-testid="promo-banner-section" className="relative pt-[150px] md:pt-[172px]">
      <div className="w-full px-3 sm:px-4 lg:px-6">
        <div
          className="group relative w-full overflow-hidden rounded-xl md:rounded-2xl border border-white/10 shadow-[0_18px_50px_-20px_rgba(0,70,120,0.45)] transition-[border-color] duration-300 hover:border-[#00AEEF]/40"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          {banners === null ? (
            <div className="w-full bg-white/[0.03] animate-pulse" style={{ aspectRatio: "1916 / 790" }} />
          ) : (
            banners.map((b, i) => (
              <Link
                key={b.id}
                to={b.link || "/shop"}
                data-testid={`promo-banner-${b.id}`}
                aria-label={b.alt || b.title}
                aria-hidden={i !== idx}
                tabIndex={i === idx ? 0 : -1}
                className={`transition-opacity duration-700 ease-in-out ${
                  i === idx
                    ? "relative block z-[1] opacity-100"
                    : "absolute inset-0 opacity-0 pointer-events-none"
                }`}
              >
                <img
                  src={resolveSrc(b.image_url)}
                  alt={b.alt || b.title}
                  loading={i === 0 ? "eager" : "lazy"}
                  fetchPriority={i === 0 ? "high" : "auto"}
                  className={i === idx ? "w-full h-auto block" : "w-full h-full object-contain"}
                />
              </Link>
            ))
          )}
          {banners && banners.length > 1 && (
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 z-[2] flex items-center gap-2">
              {banners.map((b, i) => (
                <button
                  key={b.id}
                  type="button"
                  aria-label={`Show banner ${i + 1}`}
                  data-testid={`promo-banner-dot-${i}`}
                  onClick={() => setIdx(i)}
                  className={`h-2 rounded-full transition-all duration-300 ${
                    i === idx ? "w-6 bg-white/90" : "w-2 bg-white/40 hover:bg-white/60"
                  }`}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
